import React, { Dispatch, DispatchWithoutAction, FC } from 'react';
import { ArrayField } from 'react-hook-form';

import { useI18n } from 'i18n';
import { AttributeSelect } from './attribute-select';
import { AttributeAspectsFields } from './attribute-aspects-fields';

import {
  AttributeContentStyled,
  AttributeHeaderStyled,
  DetectorAttributeStyled,
} from 'ui/pages/attribute-range-detectors/detector-attribute.styled';

interface IAttributeFieldsProps {
  isDisabled: boolean;
  mnemonics?: string;
  fields: Partial<ArrayField<Record<string, string>, 'id'>>[];
  addStringEnumeration: DispatchWithoutAction;
  removeStringEnumeration: Dispatch<number>;
}

export const AttributeFields: FC<IAttributeFieldsProps> = (props) => {
  const { isDisabled, mnemonics, ...rest } = props;

  const { fc } = useI18n();

  return (
    <DetectorAttributeStyled>
      <AttributeHeaderStyled>
        <label>{fc('attribute')}</label>
      </AttributeHeaderStyled>
      <AttributeContentStyled>
        <AttributeSelect isDisabled={isDisabled} />
        {!!mnemonics && <AttributeAspectsFields isDisabled={isDisabled} mnemonics={mnemonics} {...rest} />}
      </AttributeContentStyled>
    </DetectorAttributeStyled>
  );
};
